/* Renders Login page */

import React from 'react';
import PropTypes from 'prop-types';
import LoginForm from './LoginForm';
import LoginLogo from './LoginLogo';
import LoginLayout from './LoginLayout';

const Login = ({ hasAuthenticated, token, onSubmit, isNetworkError, failureCode, serverTimeInMillis, lockedUntil, isDeviceTokenRequired }) => {
    const handleSubmit = (username, password) => {
        onSubmit(username, password);
    };

    return (
        <LoginLayout>
            <LoginLogo />
            <LoginForm
                hasAuthenticated={hasAuthenticated}
                token={token}
                isNetworkError={isNetworkError}
                failureCode={failureCode}
                serverTimeInMillis={serverTimeInMillis}
                lockedUntil={lockedUntil}
                isDeviceTokenRequired={isDeviceTokenRequired}
                onSubmit={handleSubmit}
            />
        </LoginLayout>
    );
};

/* type checking for props */
Login.propTypes = {
    token: PropTypes.string.isRequired,
    hasAuthenticated: PropTypes.bool.isRequired,
    isNetworkError: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default Login;
